(function () {
    var $contactInfo = $('.contact-info').first();
    var $svg = $contactInfo.find('svg').height(450);

    $(document).ready(function(){
        ContactPuzzlePieceHeight();
    });
    $(window).on('resize', debounce(function() {
        ContactPuzzlePieceHeight();
    }, 250));

    var ContactPuzzlePieceHeight = function() {
        $svg.height($contactInfo.height() + 260);
    };

    function debounce(fn, delay) {
        var timer = null;
        return function () {
            var context = this, args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
                fn.apply(context, args);
            }, delay);
        };
    }
})();